import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import './CardsItemEventos.css';

function CardsItemEventos(props) {
  return (
    <Card className="evento-card">
      <Link className='cards__item__link_evento' to={props.path}>
        <div className="evento-card__media-wrap">
          <CardMedia
            component="img"
            className="evento-card__media"
            image={props.src}
            alt={props.name}
          />
        </div>

        <CardContent className="evento-card__content">
          <Typography
            className="evento-card__title"
        variant="h6"
          >
            {props.name}
          </Typography>

          <Typography className="evento-card__text" variant="body2" color="text.secondary">
            {props.text}
          </Typography>
        </CardContent>
      </Link>
    </Card>
  );
}

export default CardsItemEventos;
